import React, { useEffect } from 'react';
import * as Styles from './Confirmation.styles';
import { AlertV2 } from 'gatorcomponents';

const Confirmation = ({
  title = 'Please read the information below before confirming or canceling your subscription:',
  attentionLabel = 'Attention',
  canShowBackupLink = false,
  backupFilesLabel = 'Please back up anything you want to save before continuing.',
  backupFilesLinkLabel = 'See how to back up your files',
  onClickBackupLink,
  onStopCancel,
  stopCancelLabel = "I don't want to cancel the renewal anymore",
  attentionCancelSignatureLabel = 'By canceling this subscription, the following will occur:',
  attentionCancelExclusionLabel,
  topics = [
    'Your subscription will be canceled immediately, and you will lose access to the services you have with us.',
    'You will not be charged again for this subscription.',
  ],
  testId = 'confirmation',
  onShowPageAction,
}) => {
  useEffect(() => {
    onShowPageAction && onShowPageAction();
  }, [onShowPageAction]);

  const handleOnStopCancelClick = () => {
    onStopCancel && onStopCancel();
  };

  const hadleOnClickBackupLink = () => {
    onClickBackupLink && onClickBackupLink();
  };

  const contentSignatureCancel = (
    <Styles.Description>
      <Styles.AttentionCancelSignatureLabel>
        {attentionCancelSignatureLabel}
        {canShowBackupLink && ` ${backupFilesLabel}`}
      </Styles.AttentionCancelSignatureLabel>
      {attentionCancelExclusionLabel && (
        <Styles.AttentionCancelExclusionLabel>
          {attentionCancelExclusionLabel}
        </Styles.AttentionCancelExclusionLabel>
      )}
      {(topics.length > 0) && (
        <Styles.ListWrapper>
          <Styles.List>
            {topics.map((topic, index) => (
              <Styles.ListItem key={`${testId}-topic-${index + 1}`}>{ topic }</Styles.ListItem>
            ))}
          </Styles.List>
        </Styles.ListWrapper>
      )}
    </Styles.Description>
  );

  return (
    <Styles.Wrapper data-testid={testId}>
      <Styles.Title>
        {title}
      </Styles.Title>
      <AlertV2
        onPrimaryAction={handleOnStopCancelClick}
        primaryButtonLabel={stopCancelLabel}
        onSecondaryAction={canShowBackupLink && hadleOnClickBackupLink}
        secondaryButtonLabel={canShowBackupLink && backupFilesLinkLabel}
        title={attentionLabel}
        testId="alert"
        variant="critical"
        width="fit-content"
        withoutBackground={false}
        description={contentSignatureCancel}
      />
    </Styles.Wrapper>
  );
};

export default Confirmation;
